"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
var Select = function Select(_ref) {
  var label = _ref.label,
    disabled = _ref.disabled,
    required = _ref.required,
    name = _ref.name,
    options = _ref.options,
    placeholder = _ref.placeholder,
    invalid = _ref.invalid,
    labelHidden = _ref.labelHidden,
    id = _ref.id,
    onChange = _ref.onChange,
    value = _ref.value,
    dataRepeatType = _ref.dataRepeatType,
    alert = _ref.alert,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-select margin-bottom-sm ".concat(className)
  }, !labelHidden && /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label margin-bottom-sm",
    htmlFor: id || label.replace(/\s+/g, '-').toLowerCase(),
    "data-section": "form-label"
  }, label), /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-relative"
  }, /*#__PURE__*/_react["default"].createElement("select", {
    className: "form-control",
    disabled: disabled,
    id: id || label.replace(/\s+/g, '-').toLowerCase(),
    required: required,
    name: name,
    "aria-invalid": invalid,
    onChange: onChange,
    value: value || '',
    "data-repeat-type": dataRepeatType
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    disabled: true,
    hidden: true
  }, placeholder), options.map(function (o) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: o.value,
      value: o.value
    }, o.text);
  }))), alert && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: "margin-top-sm",
    show: alert.showNotification,
    text: alert.notificationMessage,
    type: alert.notificationType,
    onClose: alert.onClose
  }));
};
Select.propTypes = {
  label: _propTypes["default"].string,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  invalid: _propTypes["default"].bool,
  options: _propTypes["default"].array.isRequired,
  labelHidden: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  dataRepeatType: _propTypes["default"].string,
  alert: _propTypes["default"].object,
  className: _propTypes["default"].string
};
Select.defaultProps = {
  required: false,
  alert: {}
};
var _default = exports["default"] = Select;